import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api, { getApiUrl } from '../../services/api';
import './WaitlistPage.css';

export default function WaitlistPage() {
  const [searchParams] = useSearchParams();
  const uid = searchParams.get('uid');

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [emailSaved, setEmailSaved] = useState(false);

  const isValidEmail = (e: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

  const handleEmailSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!isValidEmail(trimmed)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    if (!uid) {
      setEmailError('Something went wrong. Please try signing up again.');
      return;
    }
    setEmailError('');
    setSubmitting(true);
    try {
      await api.saveWaitlistEmail(Number(uid), trimmed);
      setEmailSaved(true);
    } catch {
      setEmailError('Something went wrong. Please try again.');
      setSubmitting(false);
    }
  };

  const handleCheckApproval = () => {
    window.location.href = `${getApiUrl()}/auth/strava/login`;
  };

  // After email is saved, show confirmation
  if (emailSaved) {
    return (
      <div className="waitlist-page">
        <div className="waitlist-card">
          <div className="waitlist-icon">🏃</div>
          <h1>You're on the list!</h1>
          <p className="waitlist-lead">
            We'll email you at <strong>{email.trim()}</strong> as soon as your account is approved.
          </p>
          <p className="waitlist-sub">Already been approved?</p>
          <button className="waitlist-check-btn" onClick={handleCheckApproval}>
            Sign in with Strava
          </button>
        </div>
      </div>
    );
  }

  // First step: collect email
  return (
    <div className="waitlist-page">
      <div className="waitlist-card">
        <div className="waitlist-icon">🏃</div>
        <h1>Almost there!</h1>
        <p className="waitlist-lead">
          Enter your email so we can notify you when your account is approved.
        </p>
        <form className="waitlist-email-form" onSubmit={handleEmailSubmit}>
          <input
            type="email"
            className="waitlist-email-input"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setEmailError(''); }}
            autoFocus
            disabled={submitting}
          />
          {emailError && <p className="waitlist-error">{emailError}</p>}
          <button
            type="submit"
            className="waitlist-check-btn"
            disabled={submitting || !email.trim()}
          >
            {submitting ? 'Saving...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
